import { Log, WebStorageStateStore } from 'oidc-client-ts'
import { type PropsWithChildren, type ReactElement } from 'react'
import { AuthProvider, type AuthProviderProps } from 'react-oidc-context'
import { useEnv } from '../hooks/useEnv'
import LoadingScreen from './LoadingScreen'
import { getLocation } from '../utils/location'

const AUTH_CALLBACK_PARAM_KEYS = [
  'code',
  'scope',
  'state',
  'session_state',
  'iss'
]

function Authentication ({
  children
}: Readonly<PropsWithChildren>): ReactElement {
  const env: Record<string, string> = useEnv()
  const location = getLocation()

  if (Object.keys(env).length === 0) {
    return <LoadingScreen />
  }

  const oidcConfig: AuthProviderProps = {
    authority: env.REACT_APP_OIDC_AUTHORITY ?? '',
    client_id: env.REACT_APP_OIDC_CLIENT_ID ?? '',
    redirect_uri:
      location.href.replace(/#.*$/, '') ??
      env.REACT_APP_OIDC_REDIRECT_URL ??
      '',
    loadUserInfo: true,
    onSigninCallback: (): void => {
      const searchParams = new URLSearchParams(location.search)

      AUTH_CALLBACK_PARAM_KEYS.forEach(authParam => {
        searchParams.delete(authParam)
      })

      if (searchParams.size > 0) {
        location.search = searchParams.toString()
      } else {
        location.href = location.pathname
      }
    },
    onSignoutCallback: (): void => {
      location.pathname = ''
    },
    userStore: new WebStorageStateStore({ store: window.localStorage })
  }

  if (env.REACT_APP_ENVIRONMENT_NAME?.toLowerCase() !== 'prod') {
    Log.setLogger(console)
  }

  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>
}

export default Authentication
